import React, { useState, useEffect } from 'react'
import { Tab, Nav, Container, Row, Col } from 'react-bootstrap'
import { useLocation } from '@reach/router'
import './tab.css'

const TabComponent = () => {
  const search = useLocation().search
  const link = new URLSearchParams(search).get('link')
  const [activeTab, setActiveTab] = useState('digitalforensic')
  const activateTab = n => {
    setActiveTab(n)
  }
  useEffect(() => {
    setActiveTab(link ? link : 'digitalforensic')
  }, [])
  return (
    <Tab.Container>
      <div className="container">
        <section className="section-padding">
          <div className="row services-tabs-section">
            <div className="col nav-cell d-flex justify-content-center">
              <div
                role="presentation"
                className="nav-item"
                onClick={() => activateTab('digitalforensic')}
              >
                <Nav.Link>
                  <p className="nav-text">Electronic Evidence Collection</p>
                </Nav.Link>
              </div>
            </div>
            <div className="col nav-cell d-flex justify-content-center">
              <div
                role="presentation"
                className="nav-item"
                onClick={() => activateTab('ediscovery')}
              >
                <Nav.Link>
                  <p className="nav-text">eDiscovery</p>
                </Nav.Link>
              </div>
            </div>
            <div className="col nav-cell d-flex justify-content-center">
              <div
                role="presentation"
                className="nav-item"
                onClick={() => activateTab('cyberinvestigation')}
              >
                <Nav.Link>
                  <p className="nav-text">Cyber Investigations</p>
                </Nav.Link>
              </div>
            </div>
            <div className="col nav-cell d-flex justify-content-center">
              <div
                role="presentation"
                className="nav-item"
                onClick={() => activateTab('paperdiscovery')}
              >
                <Nav.Link>
                  <p className="nav-text">Paper Discovery</p>
                </Nav.Link>
              </div>
            </div>

            {/* Remove Staff Augmentation  */}
            {/* <div className="col nav-cell d-flex justify-content-center">
              <div
                role="presentation"
                className="nav-item"
                onClick={() => activateTab('staffaugmentation')}
              >
                <Nav.Link>
                  <p className="nav-text">Staff Augmentation</p>
                </Nav.Link>
              </div>
            </div> */}
          </div>
        </section>
      </div>

      <div className="tab-content">
        {activeTab == 'digitalforensic' && (
          <div className="tab-pane active">
            <section id="Digital-forensics">
              <div className="container pb-5">
                <div className="row">
                  <div className="col">
                    <div className="rethink-your-esi-headtext">
                      <h1>Electronic Evidence Collection</h1>
                    </div>
                    <div className="pb-5 rethink-your-esi-subtext">
                      <p>
                        With an emphasis on creating an evidentiary chain of
                        custody, Perin ensures that the data we collect is
                        verifiable and forensically sound.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-box pb-5">
                <div className="row">
                  <div className="col">
                    <div className="box">
                      <div className="container container-quote-text">
                        <img
                          className="quote-img-1"
                          src="../images/quote-1.svg"
                          alt="quote1"
                        />
                        <p className="quote-text">You focus on</p>
                        <p className="quote-text-1">the strategy,</p>
                        <p className="quote-text-2">We will focus on </p>
                        <p className="quote-text-3">the data.</p>
                        <img
                          className="quote-img-2"
                          src="../images/quote-2.svg"
                          alt="quote-2"
                        />
                      </div>
                    </div>
                    <div className="box-2">
                      <div className="container">
                        <p className="pt-3 digital-text container-service-pad">
                          Our experience allows us to examine a larger range of
                          computing devices and operating systems, including:
                        </p>
                        <ul className="order-checked order-checked-pad-security">
                          <li className="sba-list-checked digital-subtext pb-2">
                            Smart Phones ( Apple, Android, Blackberry, and
                            others )
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Emails
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Network Servers
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Cloud-based Accounts
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Social Media
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Internet-of-Things & other devices
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Computers & Laptops (Windows, Mac, & Unix)
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container pt-5 rethink-box-text">
                <p className="rethink-your-esi-quotetext">
                  Our services include analysis and reporting, consulting,
                  expert testimony, and deposition
                  <br /> consulting. We work onsite or remote and we are well
                  versed in the eDiscovery reference model
                  <br /> (EDRM) and the different processing and review
                  platforms firms use so we can be a reliable <br /> conduit
                  with your in-house or outside team to give them usable data in
                  the format they need.
                </p>
              </div>
            </section>
            <section id="ways">
              <Container>
                <Row>
                  <Col lg={12} className="m-auto">
                    <div className="text-center">
                      <span className="section-p">
                        Download Digital Forensics Overview
                      </span>
                    </div>
                    <Col lg={12} className="m-auto">
                      <div className="text-center pt-3">
                        <a
                          target="_blank"
                          href="https://perindiscovery.sharefile.com/d-s05a67f7c1f0e405799b148e0241afbbe"
                          className="btn-primary"
                        >
                          DOWNLOAD
                        </a>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        )}
        {activeTab == 'ediscovery' && (
          <div className="tab-pane active">
            <section id="eDiscovery">
              <div className="container pb-5">
                <div className="row">
                  <div className="col">
                    <div className="rethink-your-esi-headtext">
                      <h1>eDiscovery</h1>
                    </div>
                    <div className="pb-5 rethink-your-esi-subtext">
                      <p>
                        After your ESI is collected by our team or your team,
                        Perin provides a range of services from early case
                        assessment and pre-review culling to final production
                        and data repository services to support you.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-box pb-5 pt-5">
                <div className="row">
                  <div className="col">
                    <div className="box">
                      <span>
                        <h4 className="eDiscovery-txt">
                          Perin’s eDiscovery services <br /> are intended to put
                          your team <br /> in the best position to <br />{' '}
                          conduct its document review.
                        </h4>
                      </span>
                    </div>
                    <div className="eDiscovery-box-2 ">
                      <div className="container">
                        <p className="pt-3 digital-text">
                          Leveraging the Relativity and CloudNine suites of
                          software and proprietary feature enhancements, you can
                          contact Perin for a range of eDiscovery services
                          including:
                        </p>
                        <ul className="order-checked order-checked-pad-security">
                          <li className="sba-list-checked digital-subtext pb-2">
                            ESI Early Data Assessment
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Deployment and Consulting on Use of Advanced
                            Analytics
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            ESI Pre-Culling by File Type, Custodian, Date, and
                            Other
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            ESI Search & Filtering
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            ESI Processing & Loading
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Review Platform Hosting
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Review Platform Training
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Production Services
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            eDiscovery Managed Services
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Text messages and other messaging apps produced in
                            standard deliverables that work in any review
                            platform.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container esi-padding-top">
                <p className="rethink-your-esi-quotetext">
                  In our role as a consulting expert, Perin is positioned to
                  take advantage of the privileged <br /> relationship between
                  counsel and client in litigation, and often works in careful{' '}
                  <br /> coordination as testifying experts.
                </p>
              </div>
            </section>
            <section id="ways">
              <Container>
                <Row>
                  <Col lg={12} className="m-auto">
                    <div className="text-center">
                      <span className="section-p">
                        Download eDiscovery Overview
                      </span>
                    </div>
                    <Col lg={12} className="m-auto">
                      <div className="text-center pt-3">
                        <a
                          target="_blank"
                          href="https://perindiscovery.sharefile.com/d-s844526128ae149b39d97d258b89f9c4c"  
                          className="btn-primary"
                        >
                          DOWNLOAD
                        </a>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        )}

        {activeTab == 'cyberinvestigation' && (
          <div className="tab-pane active">
            <section id="cyberinvestigation">
              <div id="perindiscovery" className="container pb-5">
                <div className="row">
                  <div className="col">
                    <div className="rethink-your-esi-headtext">
                      <h1>Cyber Investigations</h1>
                    </div>
                    <div className="pb-5 rethink-your-esi-subtext">
                      <p>
                        After a breach, Perin puts the pieces back together by
                        telling the story of what happened. With cybersecurity
                        at the forefront of investigations, this story is a
                        guide for your company to remediate current and future
                        cyber challenges.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-box pb-5 pt-5">
                <div className="row">
                  <div className="col">
                    <div className="box">
                      <span>
                        <h4 className="eDiscovery-txt">
                          While the investigation is necessary, the advice to
                          move forward is paramount to protecting your business.
                        </h4>
                      </span>
                    </div>
                    <div className="box-2 ">
                      <div className="container">
                        <p className="pt-3 digital-text">
                          Cybersecurity professionals performing breach
                          investigations can support the following:
                        </p>
                        <ul className="order-checked order-checked-pad-security">
                          <li className="sba-list-checked digital-subtext pb-2">
                            Business Email Compromise
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Ransomware Infections
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Data Breaches
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Evidence preservation
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Chain of custody
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Clear, Concise, Analysis & Reporting
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Vulnerability Identification
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Cybersecurity Action Plan
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container esi-padding-top esi-padding-bottom">
                <p className="rethink-your-esi-quotetext">
                  More than an investigation, responses are led by cybersecurity
                  professionals with a goal of protecting the business.
                </p>
              </div>
            </section>
            <section id="ways">
              <Container>
                <Row>
                  <Col lg={12} className="m-auto">
                    <div className="text-center">
                      <span className="section-p">
                        Download Cyber Investigations Overview
                      </span>
                    </div>
                    <Col lg={12} className="m-auto">
                      <div className="text-center pt-3">
                        <a
                          target="_blank"
                          href="https://perindiscovery.sharefile.com/d-s2a530074350242d7a7eb755879f9e8ad"
                          className="btn-primary"
                        >
                          DOWNLOAD
                        </a>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        )}
        {activeTab == 'paperdiscovery' && (
          <div className="tab-pane active">
            <section id="paperDiscovery">
              <div id="perindiscovery" className="container pb-5">
                <div className="row">
                  <div className="col">
                    <div className="rethink-your-esi-headtext">
                      <h1>Paper Discovery</h1>
                    </div>
                    <div className="pb-5 rethink-your-esi-subtext">
                      <p>
                        At a time when documents and information are originating
                        overwhelmingly in electronic form, legacy media like
                        paper still makes up a population of evidentiary
                        evidence.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-box pb-5 pt-5">
                <div className="row">
                  <div className="col">
                    <div className="box">
                      <span>
                        <h4 className="eDiscovery-txt">
                          Whether it’s training <br /> documents or contracts,
                          paper <br /> still can be the media of <br /> document
                          record.
                        </h4>
                      </span>
                    </div>
                    <div className="box-2 ">
                      <div className="container">
                        <p className="pt-3 digital-text">
                          The company’s roots date to when paper was the
                          dominant source of information and Perin has built an
                          operation equipped to handle paper discovery
                          activities including:
                        </p>
                        <ul className="order-checked order-checked-pad-security">
                          <li className="sba-list-checked digital-subtext pb-2">
                            Scanning
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Printing
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Copying
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Conversion
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container esi-padding-top esi-padding-bottom">
                <p className="rethink-your-esi-quotetext">
                  Perin’s operations includes state of the art equipment and is
                  built to meet intense <br /> deadlines. Image outputs are
                  customized to the loadfile format and database required.
                </p>
              </div>
            </section>
            <section id="ways">
              <Container>
                <Row>
                  <Col lg={12} className="m-auto">
                    <div className="text-center">
                      <span className="section-p">
                        Download Paper Discovery Overview
                      </span>
                    </div>
                    <Col lg={12} className="m-auto">
                      <div className="text-center pt-3">
                        <a
                          target="_blank"
                          href="https://perindiscovery.sharefile.com/d-sac97b03e973b4c25879026ddcb8d5335"
                          className="btn-primary"
                        >
                          DOWNLOAD
                        </a>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        )}

        {/* Remove Staff Augmentation  */}
        {/* {activeTab == 'staffaugmentation' && (
          <div className="tab-pane active">
            <section id="staffAugmentation">
              <div className="container pb-5">
                <div className="row">
                  <div className="col">
                    <div className="rethink-your-esi-headtext">
                      <h1>Staff Augmentation</h1>
                    </div>
                    <div className="pb-5 rethink-your-esi-subtext">
                      <p>
                        Finding quality and reliable personnel to fulfill case
                        projects can be a challenge and Perin’s blended
                        technology and people approach provides you a source for
                        review and production of datasets of any size.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-box pb-5 pt-5">
                <div className="row">
                  <div className="col">
                    <div className="box">
                      <span>
                        <h4 className="eDiscovery-txt">
                          For all the activities beyond <br /> automation, the
                          right mix of <br /> technology and people can <br />{' '}
                          achieve the outcomes you’re <br /> seeking.
                        </h4>
                      </span>
                    </div>
                    <div className="box-2 ">
                      <div className="container">
                        <p className="pt-3 digital-text">
                          Whether you need attorneys, paralegals, FOIA
                          specialists, or, records and project managers, Perin
                          has the technology and processes in place for document
                          reviews of different types of information requests,
                          including:
                        </p>
                        <ul className="order-checked order-checked-pad-security">
                          <li className="sba-list-checked digital-subtext pb-2">
                            First pass reviews
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Records cleansing projects
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            Special projects
                          </li>
                          <li className="sba-list-checked digital-subtext pb-2">
                            FOIA responses
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container esi-padding-top esi-padding-bottom">
                <p className="rethink-your-esi-quotetext">
                  Perin is an eDiscovery firm first and we believe this is
                  important for your case projects. A reliable and <br /> tested
                  workflow managed through outcome-based metrics by experienced
                  technology and legal managers <br /> is the foundation of any
                  review.
                </p>
              </div>
            </section>
            <section id="ways">
              <Container>
                <Row>
                  <Col lg={12} className="m-auto">
                    <div className="text-center">
                      <span className="section-p">
                        Download Staff Augmentation Overview
                      </span>
                    </div>
                    <Col lg={12} className="m-auto">
                      <div className="text-center pt-3">
                        <a
                          target="_blank"
                          href="https://perindiscovery.sharefile.com/d-sa40cc5949a4c4e6abf97f4d4c20f5cff "
                          className="btn-primary"
                        >
                          DOWNLOAD
                        </a>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        )} */}
      </div>
    </Tab.Container>
  )
}

export default TabComponent
